import React from 'react';
import { Switch } from './forms/Controls'
import styles from './Toggle.module.css';

export function Toggle({
  checked,
  onChange,
  label,
  labelExtra,
  disabled = false,
  size = 'medium',
  showStatus = false
}) {
  return <Switch role="checkbox" checked={checked} onChange={onChange} disabled={disabled} label={<>{label}{labelExtra}</>} description={showStatus ? (checked ? 'Active' : 'Inactive') : undefined} className={styles[size]} />
}

export function ToggleGroup({ children, label }) {
  return (
    <div className={styles.toggleGroup}>
      {label && <div className={styles.groupLabel}>{label}</div>}
      <div className={styles.toggles}>{children}</div>
    </div>
  );
}
